import { render, staticRenderFns } from "./FlexboxItem.vue?vue&type=template&id=58a08fe8"
import script from "./FlexboxItem.vue?vue&type=script&lang=js"
export * from "./FlexboxItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58a08fe8')) {
      api.createRecord('58a08fe8', component.options)
    } else {
      api.reload('58a08fe8', component.options)
    }
    module.hot.accept("./FlexboxItem.vue?vue&type=template&id=58a08fe8", function () {
      api.rerender('58a08fe8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Flexbox/FlexboxItem.vue"
export default component.exports